<template>
    <CustomTopSheetDialog v-model="show" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('shop.profile.productGroupDialog.title') }}
            </h3>
        </template>

        <template #default>
            <p>
                {{ $t('shop.profile.productGroupDialog.description') }}
            </p>
            <v-row clasS="mb-0 py-0" justify="start">
                <v-col cols="12" sm="6" lg="4" class="pl-0">
                    <v-autocomplete v-model="ProductGroupSearch" @update:search="onSearch" variant="outlined"
                        density="compact" :hide-details="true" :items="filteredItems" item-title="value"
                        return-object="true" :placeholder="$t('shop.profile.productGroupDialog.searchText')"
                        @update:model-value="onSelectItem" v-bind:menu="menu" hide-no-data>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-btn color="primary" variant="text" class="mb-2" @click="expand = !expand">{{
                $t('shop.profile.productGroupDialog.suggestLink') }} </v-btn>
            <v-expand-transition>
                <v-card v-show="expand" class="" height="auto" variant="flat">
                    <v-row>
                        <v-col cols="12" sm="6" lg="4">
                            <v-text-field v-model="suggestion" variant="outlined" density="compact" :hide-details="true"
                                :placeholder="$t('shop.profile.productGroupDialog.suggestPlaceholder')">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-btn class="mt-2" rounded="xl" size="large" variant="flat" base-color="primary">
                        {{ $t('shop.profile.productGroupDialog.button.suggest') }} </v-btn>
                </v-card>
            </v-expand-transition>
            <p class="mt-3">
                {{ $t('shop.profile.productGroupDialog.productGroupSearch') }}
            </p>
            <v-divider></v-divider>
            <v-row justify="start" justify-md="center" class="">
                <v-col cols="12" class="p-0">
                    <v-breadcrumbs :items="breadCrumbHistory">
                                    <template v-slot:divider>
                                        <v-icon icon="mdi-chevron-right"></v-icon>
                                    </template>
                                    <template v-slot:title="{item}">
                                        {{item.translations ? item.translations[selectedLanguage.toUpperCase()].value : item.value}}
                                    </template>
                                </v-breadcrumbs>
                </v-col>
                <v-col cols="12" md="4" class="list-column px-2">
                    <!-- {{ breadCrumbHistory }} -->
                    <v-btn v-if="selectedItem" size="small" color="default" flat fab icon="mdi-chevron-left"
                        class="back-button" @click="goBack"></v-btn>
                    <v-list density="compact">
                        <v-list-item @click="() => selectGroup(group)" color="primary" v-for="group in productGroups"
                            :key="group.id" variant="outlined" style="border: 1px solid #ddd">
                            {{ group.translations[selectedLanguage.toUpperCase()].value }}
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col class="px-2" cols="12" md="4">
                    <v-text-field class="readonly-selection"
                        :placeholder="$t('shop.profile.productGroupDialog.noSelection')" variant="outlined"
                        density="compact" :hide-details="true" readonly="true" :value="typeof selectedItem?.translations == 'undefined' ? selectedItem?.value: selectedItem.translations[selectedLanguage.toUpperCase()].value">
                    </v-text-field>
                    <v-btn :disabled="!selectedItem" class="mt-2" rounded="xl" size="large" variant="flat"
                        base-color="primary" append-icon="mdi-chevron-right" @click="addGroup">
                        {{ $t('entity.action.add') }} </v-btn>
                </v-col>
                <v-col class="px-2" cols="12" md="4">
                    <v-list>
                        <v-list-item v-for="item in selectedItems" :key="item.id" variant="outlined">
                            {{ item.translations[selectedLanguage.toUpperCase()].value }}

                            <template v-slot:prepend>
                                <v-btn variant="flat" size='x-small' color="error" fab icon="mdi-minus" class="mr-3"
                                    @click="() => removeGroup(item.id)">
                                </v-btn>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="closeSheet">{{ $t('entity.action.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
import { inject } from 'vue'
export default {
    name: "EditShopBrandsDialog",
    methods: {

    },
};


</script>
<script setup>
import { ref, watch, computed, defineProps, defineEmits, getCurrentInstance, onMounted } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const expand = ref(false);
const ProductGroupSearch = ref(null)
const suggestion = ref('');
const productGroups = ref([]);
const originalShop = inject('shop');
// const  = ref(Object.assign({}, orignalShop.value));
const shop = ref({ ...originalShop.value });
const { proxy } = getCurrentInstance();
const filteredItems = ref([]);
const loading = ref(false);
const selectedItems = ref([]);
const selectedItem = ref(null);
const menu = ref(false);
const fetchOwnShop = inject('fetchOwnShop');
const selectedLanguage = localStorage.getItem('selectedLanguage');
// firstProductCategory.value = Object.values(shop.value.productCategories);
const selectedHistory = ref([]);
const breadCrumbHistory = ref([]);
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");

onMounted(() => {
    fetchProductGroups();
});



const fetchProductGroups = async (group = null) => {

    var obj;
    if (group == null) {
        obj = {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        }
    } else {
        obj = {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
            params: {
                id: group
            }
        }
    }
    try {
        const response = await proxy.$axios.get("/shop/productGroup", obj);

        // Update filteredItems with the API response
        productGroups.value = response.data.data.children || [];
        return productGroups.value;
    } catch (error) {
        console.error("Error fetching search results:", error);
    }
};

const selectGroup = async (group) => {
    console.log(group);
    if (selectedItem.value) {
        selectedHistory.value.push(selectedItem.value); // Save previous selection to history
    }
    breadCrumbHistory.value.push(group)
    selectedItem.value = group; // Set the new selected item
    await fetchProductGroups(group.id); // Fetch data for the selected group
};

const goBack = async () => {
    const lastSelection = selectedHistory.value.pop(); // Get the previous selection from history
    breadCrumbHistory.value.pop();
    if (lastSelection) {
        selectedItem.value = lastSelection; // Set the previous selection
        await fetchProductGroups(lastSelection.id); // Fetch data for the previous group
    } else {
        selectedItem.value = null
        await fetchProductGroups();
    }
};

watch(() => originalShop.value, (newShop) => {
    if (!newShop) return;
    shop.value = { ...newShop }; // Create a fresh copy when the original shop changes
    selectedItems.value = shop.value.productGroups
}, { deep: true, immediate: true });

// watch(() => selectedItem.value, (newItem, oldItem) => {
//     if (newItem.id == oldItem) return;
//     selectedItems.value = fetchProductGroups(selectedItem?.value.id);
// }, { deep: true});

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },

});

const addGroup = async () => {

    try {
        const response = await proxy.$axios.put("/shop/productGroup", { id: selectedItem?.value.id }, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.value.status == 200) {
            selectedItems.value = [...selectedItems.value, selectedItem?.value]
        }
        console.log('selectedItems.value////////////////', selectedItems.value);
    } catch (error) {
        console.error("Error fetching search results:", error);
    } finally {
        fetchOwnShop();
    }
}


// fetch : /api/shop/brand/query?keyword=ka

const onSearch = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
        filteredItems.value = []; // Clear the items when input is empty
        return;
    }

    loading.value = true;
    try {
        const response = await proxy.$axios.get("/shop/productGroup/search", {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
            params: {
                keyword: searchTerm,
                language: selectedLanguage.toUpperCase()
            },
        });

        // Update filteredItems with the API response
        filteredItems.value = response.data.data || [];
    } catch (error) {
        console.error("Error fetching search results:", error);
        filteredItems.value = [];
    } finally {
        loading.value = false;
    }
};

const onSelectItem = async (item) => {
    breadCrumbHistory.value = [];
    selectedItem.value = null;
    // Find selected item
    selectGroup(item);
    ProductGroupSearch.value = null;
};

const removeGroup = async (itemId) => {
    try {
        const response = await proxy.$axios.delete(`/shop/productGroup/${itemId}`, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            selectedItems.value = selectedItems.value.filter(item => item.id !== itemId)
        }

        // Update filteredItems with the API response
    } catch (error) {
        console.error("Error deleting Obj:", error);
    } finally {
        fetchOwnShop();
    }
}

const emit = defineEmits(['update:modelValue'])



const show = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    },
});

const closeSheet = () => {
    show.value = false;
}



</script>
<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}
</style>

<style scoped>
.list-column {}
</style>
